export default {
  questionnaire_details: 'Questionnaire details',
  questionnaire_submit_success: 'Questionnaire submitted successfully',
  questionnaire_bcak_list: 'Back to list',
  questionnaire_no: 'No questionnaire yet',
}
